import { useRef } from "react";

import { useCounter } from "common/hooks";
import { useIntersectionObserver } from "common/utils/dom";

type CounterProps = {
  value: number;
  initial?: number;
  duration?: number;
  formatter?: (value: number) => any;
};

const Counter = (props: CounterProps) => {
  const { value, initial = 0, duration = 300, formatter = (v) => v } = props;
  const { count, start } = useCounter({ initial, value, duration });
  const ref = useRef<HTMLElement>(null);

  useIntersectionObserver(ref, start, { threshold: 1 });

  return <span ref={ref}>{formatter(count)}</span>;
};

export default Counter;
